var _path, _path2, _path3, _path4, _path5, _ellipse;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPayNow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 14.7241C7.5 12.2921 12.9167 17.3235 2.50153 15.2925C2.50153 10.6433 2.49914 9.86566 2.50033 5.21752C12.9167 7.26062 7.08333 2.61607 17.5 4.64798V14.7241Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3594 7.5013C15.9787 7.5013 14.8594 6.43531 14.8594 5.12035C14.8594 4.78173 14.9336 4.45962 15.0674 4.16797",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81998 5.8324C5.95069 7.20691 4.99544 8.42208 3.68639 8.54656C3.34928 8.57862 3.02159 8.53522 2.71859 8.42963",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9273 14.5275C14.5699 13.1939 15.3099 11.8368 16.5801 11.4965C16.9072 11.4089 17.2375 11.3972 17.5538 11.4509",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 12.4987C3.88071 12.4987 5 13.5647 5 14.8797C5 15.2183 4.92578 15.5404 4.79198 15.832",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.4154,
    cy: 10.0013,
    rx: 2.08333,
    ry: 2.08333,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPayNow);
export default __webpack_public_path__ + "static/media/icon-pay-now.30fe8dee2cbcd014ca7a5d910bb20995.svg";
export { ForwardRef as ReactComponent };